import { render, staticRenderFns } from "./Specialties.vue?vue&type=template&id=3def28e2&scoped=true"
import script from "./Specialties.vue?vue&type=script&lang=js"
export * from "./Specialties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3def28e2",
  null
  
)

export default component.exports